import { LitEntity, html, css } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';

class BnModalButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean, attribute: 'show-modal', reflect: true },
      buttonClass: { type: String, attribute: 'button-class' },
      modal: { type: Object, attribute: false },
      fullWidth: { type: Boolean, attribute: 'full-width' },
      closeOnSuccess: { type: Boolean, attribute: 'close-on-success' },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host([full-width]) {
        width: 100%;
      }
    `];
  }

  render() {
    return html`
      <button class="button ${this.buttonClass}" @click="${this._onClick}" ?full-width=${this.fullWidth}>
        <slot name="text"></slot>
      </button>

      <slot name="modal" @slotchange="${this._onSlotChange}"></slot>
    `;
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }

  _onSlotChange() {
    const nodes = this.shadowRoot.querySelector('slot[name="modal"]').assignedNodes();
    this.modal = nodes.length > 0 ? nodes[0] : undefined;
    if (this.modal) {
      this.modal.addEventListener('close', () => this.showModal = false);
      this.modal.addEventListener('response', () => this.closeOnSuccess && (this.showModal = false));
      this._updateModal();
    }
  }

  updated() {
    this._updateModal();
  }

  _updateModal() {
    if (!this.modal) {
      return;
    }
    if (this.showModal) {
      this.modal.removeAttribute('hide');
    } else {
      this.modal.setAttribute('hide', '');
    }
  }
}

window.customElements.define('bn-modal-button', BnModalButton);
